var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',{staticClass:"picture",style:({backgroundImage: ("url(" + (_vm.user.avatar) + ")")})})}
var staticRenderFns = []

export { render, staticRenderFns }